import { FieldErrors } from 'react-hook-form';
import { IIndexable } from '../../../model/IIndexable';

/** Hook para configuraciones de accesibilidad relacionadas a los errores de validación */
export function useInputAriaErrors(fieldName: string, errorCollection: FieldErrors<IIndexable>, required: boolean | undefined) {
  const hasError = fieldName && errorCollection && !!errorCollection[fieldName]?.message;

  const errorId = `${fieldName}_error`;

  return {
    'aria-invalid': hasError,
    'aria-describedby': errorId,
    'aria-required': required,
  };
}
